export const ONBOARDING_SUBMIT = 'ONBOARDING_SUBMIT';
export const SET_ONBOADING_FIELDS = 'SET_ONBOADING_FIELDS';
export const CLEAR_STORES = 'CLEAR_STORES';



// WEBPACK FOOTER //
// ./src/app/stores/onboarding/onboarding-constants.js